import * as BasicBreakpoint from './BasicBreakpoint';

export const BREAKPOINT_SM = BasicBreakpoint.SM;
export const BREAKPOINT_MD = BasicBreakpoint.MD;
export const BREAKPOINT_LG = BasicBreakpoint.LG;
export const BREAKPOINT_XL = BasicBreakpoint.XL;

const GenericBreakpoint = {
    BREAKPOINT_SM,
    BREAKPOINT_MD,
    BREAKPOINT_LG,
    BREAKPOINT_XL,
};

export default GenericBreakpoint;
